import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'
import SuccessHandler from '../SuccessHandler'

/* private PurchseOrders Types */
import {
  Settings,
  _PurchaseOrder
} from '../namespace-helper'

import _ from 'lodash'

// selected item template
const selectedPurchaseOrderTemplate = {
  id: 0,
  customers_id: 0,
  accounts_id: 0,
  inquiries_id: 0,
  purchase_orders_number: '',
  valid_until: '',
  purchase_orders_status_id: 0,
  documents_id: 0,
  customer_purchase_order_number: null,
  messages_id: null,
  message: {
    attachments: [
      {
        documents_id: 0
      }
    ]
  }
}

export default {
  namespaced: true,
  state: {
    purchaseOrders: [],
    selectedPurchaseOrder: _.cloneDeep(selectedPurchaseOrderTemplate),
    openDialog: false,
    creatingPurchaseOrderMessage: false,
    purchaseOrderDocumentViewToken: null,
    unconfirmedOfferPositions: [],
    creatingPurchaseOrderPositions: false
  },
  mutations: {
    [_PurchaseOrder.mutations.setPurchaseOrders] (state, payload) {
      state.purchaseOrders = payload
    },
    [_PurchaseOrder.mutations.setCreatingPurchaseOfferPositions] (state, payload) {
      state.creatingPurchaseOrderPositions = payload
    },
    [_PurchaseOrder.mutations.setUnconfirmedOfferPositions] (state, payload) {
      state.unconfirmedOfferPositions = payload
    },
    [_PurchaseOrder.mutations.setSelectedPurchaseOrder] (state, payload) {
      if (payload !== null) {
        state.selectedPurchaseOrder = payload
      } else {
        state.selectedPurchaseOrder = _.cloneDeep(selectedPurchaseOrderTemplate)
      }
    },
    [_PurchaseOrder.mutations.setOpenCloseDialogState] (state) {
      state.openDialog = !state.openDialog
    },
    [_PurchaseOrder.mutations.setCreatingPurchaseOrderMessage] (state, payload) {
      state.creatingPurchaseOrderMessage = payload
    },
    [_PurchaseOrder.mutations.setPurchaseOrderDocumentViewToken] (state, payload) {
      state.purchaseOrderDocumentViewToken = payload
    }
  },
  actions: {
    [_PurchaseOrder.actions.savePurchaseOrder] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      const data = JSON.stringify(payload)
      return new Promise((resolve, reject) => {
        if (payload.id === 0) {
          var url = API_URL + '/api/v1/purchaseOrders'

          axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            ErrorHandler.clear(store)
            context.commit(_PurchaseOrder.mutations.setSelectedPurchaseOrder, r.data.data)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            resolve(r)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        } else {
          url = API_URL + '/api/v1/purchaseOrders/' + payload.id

          axios.put(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            ErrorHandler.clear(store)
            context.commit(_PurchaseOrder.mutations.setSelectedPurchaseOrder, r.data.data)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            resolve(r)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        }
      })
    },
    [_PurchaseOrder.actions.loadPurchaseOrders] (context, payload) {
      console.log('loadPurchaseOrders: ' + JSON.stringify(payload))
      console.log('loadPurchaseOrders: ' + payload.sortBy + ' ' + payload.descending + ' ' + payload.page + ' ' + payload.limit)

      var url = API_URL + '/api/v1/purchaseOrders?limit=' + payload.limit +
                '&page=' + payload.page +
                '&search=' + payload.search +
                '&searchFields=id:like;' +
          'purchase_orders_number:like;' +
          'customer.name:like;' +
          'account.firstname:like;' +
          'purchaseOrdersStatus.name:like;' +
          'customer_purchase_order_number:like;' +
          'purchaseOrdersPositions.product.reference:like;' +
          'purchaseOrdersPositions.internal_number:like' +
          '&orderBy=' + payload.sortBy + '&sortedBy=' + payload.descending

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        console.log('loadedOffers: ' + JSON.stringify(r.data.data))
        context.commit(_PurchaseOrder.mutations.setPurchaseOrders, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_PurchaseOrder.actions.loadUnconfirmedOfferPositions] (context, payload) {
      console.log('loadUnconfirmedOfferPositions: ' + JSON.stringify(payload))
      console.log('loadUnconfirmedOfferPositions: ' + payload.sortBy + ' ' + payload.descending + ' ' + payload.page + ' ' + payload.limit)

      var url = API_URL + '/api/v1/purchaseOrders/unconfirmedOfferPositions/' + payload.id + '?limit=' + payload.limit +
              '&page=' + payload.page +
              '&search=' + payload.search +
              '&searchFields=id:like;' +
          'product.reference:like;' +
          'product.manufacturer.name:like;' +
          'inquiryPosition.internal_number:like;' +
          'quantity:like;' +
          'customersOffer.offer_number:like' +
          '&orderBy=' + payload.sortBy + '&sortedBy=' + payload.descending

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        console.log('loadOffersPositions: ' + JSON.stringify(r.data.data))
        context.commit(_PurchaseOrder.mutations.setUnconfirmedOfferPositions, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_PurchaseOrder.actions.openCloseDialog] ({ commit }) {
      commit(_PurchaseOrder.mutations.setOpenCloseDialogState)
    },
    [_PurchaseOrder.actions.setSelectedPurchaseOrder] ({ commit }, payload) {
      commit(_PurchaseOrder.mutations.setSelectedPurchaseOrder, payload)
    },
    /*    [_PurchaseOrder.actions.createForInquiry] (context, payload) {
      context.commit(_PurchaseOrder.mutations.setCreatingPurchaseOrderFromCustomerOffer, true)

      let data = JSON.stringify(payload)

      var url = API_URL + '/api/v1/purchaseOrders/createFromCustomerOffer'
      return new Promise((resolve, reject) => {
        axios.post(url, data, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + store.getters.getBearerToken
          }
        }
              ).then(function (r) {
                context.commit(_PurchaseOrder.mutations.setCreatingPurchaseOrderFromCustomerOffer, false)
                ErrorHandler.clear(store)
                SuccessHandler.handleApiSuccess(store, r.data.message)
                resolve(r)
              }, function (err) {
                context.commit(_PurchaseOrder.mutations.setCreatingPurchaseOrderFromCustomerOffer, false)
                ErrorHandler.handleApiError(store, err)
                reject(err)
              }).catch(e => console.error('#### ' + e))
      })
    }, */
    [_PurchaseOrder.actions.createPurchaseOrderMessage] (context, payload) {
      context.commit(_PurchaseOrder.mutations.setCreatingPurchaseOrderMessage, true)

      var url = API_URL + '/api/v1/purchaseOrders/' + payload + '/createPurchaseOrderMessage'
      return new Promise((resolve, reject) => {
        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          context.commit(_PurchaseOrder.mutations.setCreatingPurchaseOrderMessage, false)
          ErrorHandler.clear(store)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          resolve(r)
        }, function (err) {
          context.commit(_PurchaseOrder.mutations.setCreatingPurchaseOrderMessage, false)
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_PurchaseOrder.actions.reloadSelectedPurchaseOrder] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      var url = API_URL + '/api/v1/purchaseOrders/' + payload
      return new Promise((resolve, reject) => {
        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          context.commit(_PurchaseOrder.mutations.setSelectedPurchaseOrder, r.data.data)
          resolve(r)
        }, function (err) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_PurchaseOrder.actions.getDocumentViewTokenByCustomerOfferId] (context, payload) {
      console.log('getDocumentViewTokenByPurchaseOrderId: ' + JSON.stringify(payload))
      var url = API_URL + '/api/v1/purchaseOrders/documentToken/' + payload.id + '?filename=' + payload.filename

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_PurchaseOrder.mutations.setPurchaseOrderDocumentViewToken, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_PurchaseOrder.actions.loadStatuses] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      return new Promise((resolve, reject) => {
        var url = API_URL + '/api/v1/purchaseOrderStatuses'

        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_PurchaseOrder.actions.createOrderPositions] (context, payload) {
      context.commit(_PurchaseOrder.mutations.setCreatingPurchaseOfferPositions, true)

      const data = JSON.stringify(payload)
      return new Promise((resolve, reject) => {
        var url = API_URL + '/api/v1/purchaseOrders/createOrderPositions'

        axios.post(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          context.commit(_PurchaseOrder.mutations.setCreatingPurchaseOfferPositions, false)
          ErrorHandler.clear(store)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          resolve(r)
        }, function (err) {
          context.commit(_PurchaseOrder.mutations.setCreatingPurchaseOfferPositions, false)
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_PurchaseOrder.actions.createProcurement] (context, payload) {
      console.log('createProcurement: ' + JSON.stringify(payload))
      var url = API_URL + '/api/v1/purchaseOrders/' + payload.id + '/createProcurement'

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        SuccessHandler.handleApiSuccess(store, r.data.message)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_PurchaseOrder.actions.loadPurchaseOrderById] (context, payload) {
      console.log('loadPurchaseOrderById: ' + JSON.stringify(payload))
      var url = API_URL + '/api/v1/purchaseOrders/' + payload

      return new Promise((resolve, reject) => {
        return axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          ErrorHandler.clear(store)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_PurchaseOrder.actions.sendOrderConfirmation] (context, payload) {
      console.log('sendOrderConfirmation: ' + JSON.stringify(payload))
      var url = API_URL + '/api/v1/purchaseOrders/' + payload.id + '/sendPurchaseOrder'

      store.commit(Settings.mutations.setLoading, true)

      const data = JSON.stringify(payload)
      return new Promise((resolve, reject) => {
        return axios.put(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          ErrorHandler.clear(store)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_PurchaseOrder.actions.resetState] ({ commit }, payload) {
      commit(_PurchaseOrder.mutations.setPurchaseOrders, [])
      commit(_PurchaseOrder.mutations.setUnconfirmedOfferPositions, [])
      commit(_PurchaseOrder.mutations.setSelectedPurchaseOrder, null)
    }
  },
  getters: {
    [_PurchaseOrder.getters.purchaseOrders] (state) {
      return state.purchaseOrders
    },
    [_PurchaseOrder.getters.unconfirmedOfferPositions] (state) {
      return state.unconfirmedOfferPositions
    },
    [_PurchaseOrder.getters.getOpenDialogState] (state) {
      return state.openDialog
    },
    [_PurchaseOrder.getters.getSelectedPurchaseOrder] (state) {
      return state.selectedPurchaseOrder
    },
    [_PurchaseOrder.getters.getCreatingPurchaseOrderMessage] (state) {
      return state.creatingPurchaseOrderMessage
    },
    [_PurchaseOrder.getters.getPurchaseOrderDocumentViewToken] (state) {
      return state.purchaseOrderDocumentViewToken
    },
    [_PurchaseOrder.getters.creatingPurchaseOrderPositions] (state) {
      return state.creatingPurchaseOrderPositions
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/PurchaseOrder/purchaseOrders.js